import { Modal, Form, Button } from "antd";
import { useDispatch, useSelector } from 'react-redux';
import { standardQuestionSliceDispatch } from "../../Constants/ReduxConstants";
import { UploadFile } from './StandardQuestionHelper';

const DeleteConfirmationModal = () => {
    const dispatch = useDispatch();
    const open = useSelector((state: any) => state.standardQuestionViewer.deleteModalOpen);
    const selectedQuestion = useSelector((state: any) => state.standardQuestionViewer.selectedQuestion);
    const questions = useSelector((state: any) => state.standardQuestionViewer.questions);

    const onCancel = () => {
        dispatch({ type: standardQuestionSliceDispatch.setSelectedQuestion, payload: {} });
        dispatch({ type: standardQuestionSliceDispatch.setDeleteModalOpen, payload: false });
    }
    
    const onSubmit = async () => {
        const updatedQuestionList = questions.filter(q => q.dataField !== selectedQuestion.dataField);
        await UploadFile(updatedQuestionList);
        dispatch({ type: standardQuestionSliceDispatch.setSelectedQuestion, payload: {} });
        dispatch({ type: standardQuestionSliceDispatch.setQuestions, payload: updatedQuestionList });
        dispatch({ type: standardQuestionSliceDispatch.setDeleteModalOpen, payload: false });
    }

    return (
        <Modal
            title="Delete?"
            footer={null}
            closable={true}
            open={open}
            destroyOnHidden={true}
            onCancel={onCancel}>
            <Form
                onFinish={onSubmit}
                onFinishFailed={onCancel}
                preserve={false}>
                <div>
                    Are you sure you want to delete this question?
                </div>
                <div style={{ display: 'flex', justifyContent: 'end', paddingTop: '1em' }}>
                    <Form.Item>
                        <Button onClick={onCancel}>
                            Cancel
                        </Button>
                    </Form.Item>
                    <Form.Item>
                        <Button htmlType="submit">
                            Submit
                        </Button>
                    </Form.Item>
                </div>
            </Form>
        </Modal>
    )
}

export default DeleteConfirmationModal;